import { createContext, useContext, useReducer } from "react";
import { LoadingStates, SDKParamsReducer } from "../utils/Reducers/Reducers";

export const SDKParams = createContext();

function SDKParamsContext({ children }) {
    const [sdkParams, dispatchSdkParamsContext] = useReducer(SDKParamsReducer, {
        isLoading: LoadingStates.pending,
        data: {},
        connectionRetryCount: 0,
    });

    const val = {
        loading: sdkParams.isLoading,
        sdkParams: sdkParams.data,
        connectionRetryCount: sdkParams.connectionRetryCount,
        dispatchSdkParamsContext,
    };

    return <SDKParams.Provider value={val}>{children}</SDKParams.Provider>;
}

export const SDKParamsState = () => useContext(SDKParams);

export default SDKParamsContext;
